import { Injectable } from '@angular/core';
import { Address } from '@checkout/const';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CheckoutActions } from '../store/actions';
import { StateWithCustomCheckout } from '../store/checkout-state';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class DeliveryAddressFacade {
  constructor(private store: Store<StateWithCustomCheckout>) {}

  loadSavedAddressList(): void {
    this.store.dispatch(new CheckoutActions.LoadSavedDeliveryAddressList());
  }

  getAddressList(): Observable<Address[]> {
    return this.store.pipe(select(CheckoutSelectors.getAddressList));
  }

  getAddress(id: string): Observable<Address> {
    return this.getAddressList().pipe(map((list: Address[]) => list?.find((address: Address) => address.id === id)));
  }

  getAddressListLength(): Observable<number> {
    return this.getAddressList().pipe(map((list: Address[]) => list?.length || 0));
  }

  resetSavedAddressList(): void {
    this.store.dispatch(new CheckoutActions.LoadSavedDeliveryAddressListReset());
  }

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getAddressListLoading));
  }

  getSuccess(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getAddressListSuccess));
  }

  getActiveAddressId(): Observable<string | undefined> {
    return this.store.pipe(select(CheckoutSelectors.getActiveAddressId));
  }

  selectActiveAddressId(id: string): void {
    this.store.dispatch(new CheckoutActions.SelectActiveDeliveryAddress(id));
  }

  saveAddress(address: Address): void {
    this.store.dispatch(new CheckoutActions.SaveDeliveryAddress(address));
  }

  editSavedAddress(address: Address): void {
    this.store.dispatch(new CheckoutActions.EditSavedDeliveryAddress(address));
  }

  deleteSavedAddress(id: string): void {
    this.store.dispatch(new CheckoutActions.DeleteSavedDeliveryAddress(id));
  }
}
